/**
 * Application Configuration
 *
 * This file contains configuration settings for the CSV Categorizer PWA.
 * Update these values to match your specific requirements.
 */

// Debug configuration
export const DEBUG_CONFIG = {
  enabled: false,
  failImmediately: true, // When true, throws errors immediately instead of handling them
  noRetry: true, // When true, prevents retrying failed operations
};

// Offline functionality configuration
export const OFFLINE_CONFIG = {
  enabled: false, // When false, offline functionality is disabled
};

// Available categories for classification
export const CATEGORIES = [
  { name: "Donation", id: "donation", color: "bg-blue-500" },
  { name: "Equipment", id: "equipment", color: "bg-purple-500" },
  { name: "Lodging", id: "lodging", color: "bg-indigo-500" },
  { name: "Materials", id: "materials", color: "bg-red-500" },
  { name: "Meals", id: "meals", color: "bg-pink-500" },
  { name: "Office Supplies", id: "office-supplies", color: "bg-blue-500" },
  { name: "Research", id: "research", color: "bg-green-500" },
  { name: "Services", id: "services", color: "bg-yellow-500" },
  { name: "Transportation", id: "transportation", color: "bg-purple-500" },
  { name: "Other", id: "other", color: "bg-pink-500" },
];

// Sheet options for the dropdown selector
export const SHEET_OPTIONS = [
  {
    spreadsheetId: "1a8nNleoGOdAElERjZqg7Q9Y_MjoDSG368Q2dvDOtOnQ",
    sheetRange: "'Amex 2024'!A1:Z1264",
    displayName: "Amex 2024",
  },
  {
    spreadsheetId: "1a8nNleoGOdAElERjZqg7Q9Y_MjoDSG368Q2dvDOtOnQ", // Same spreadsheet ID
    sheetRange: "'BoA 2024'!A1:Z200",
    displayName: "BoA 2024",
  }
];

// Default Spreadsheet ID (used if no query parameter is provided)
const DEFAULT_SPREADSHEET_INDEX = 0;

// Google Sheets configuration
export const GOOGLE_SHEETS_CONFIG = {
  // Use spreadsheet ID from URL parameter or default
  spreadsheetId: SHEET_OPTIONS[0].spreadsheetId,

  // Range of data to fetch (e.g., 'Sheet1!A1:Z1000')
  sheetRange: SHEET_OPTIONS[0].sheetRange,

  // OAuth2 configuration (for write operations)
  oauth: {
    // Replace with your OAuth2 client ID from Google Cloud Console
    clientId:
      "984370130472-tko4bpghoeeclteablq8org7d59mqki1.apps.googleusercontent.com",

    // Scopes required for Google Sheets API
    scopes: [
      "https://www.googleapis.com/auth/spreadsheets", // Full access to all spreadsheets
      // Alternative more limited scopes:
      // 'https://www.googleapis.com/auth/spreadsheets.readonly', // Read-only access
      // 'https://www.googleapis.com/auth/drive.file', // Access to files created or opened by the app
    ],

    // Whether to use OAuth2 for all operations (true) or only for write operations (false)
    useForAllOperations: true,
  },
};

// IndexedDB configuration for offline storage
export const DB_CONFIG = {
  name: "csv-categorizer-db",
  version: 4, // Incremented to trigger database upgrade for auth token storage
  stores: {
    rows: "id, category",
    syncQueue: "id, timestamp",
    auth: "id", // Now stores both auth status and token data
    categories: "id", // Added categories store for customization
  },
};

// PWA configuration
export const PWA_CONFIG = {
  appName: "CSV Categorizer",
  shortName: "Categorizer",
  description: "A PWA for categorizing CSV data",
  backgroundColor: "#ffffff",
  themeColor: "#4a5568",
};
